import { render, staticRenderFns } from "./SKDataTablelink.vue?vue&type=template&id=160bc304&"
import script from "./SKDataTablelink.vue?vue&type=script&lang=js&"
export * from "./SKDataTablelink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports